import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    Area,
    CartesianGrid,
    ComposedChart,
    Legend,
    Line,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";

const ServerOnlineChart = ({ data }) => (
    <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
            Посещаемость сервера за 24 часа
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
            <ComposedChart data={data}>
                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tickFormatter={(date) => date.split(" ")[1]} />
                <YAxis />
                <Tooltip
                    formatter={(value, name) => {
                        if (name === "players") return [`${value}`, "Игроков"];
                        if (name === "max_players") return [`${value}`, "Максимум игроков"];
                        return value;
                    }}
                />
                <Legend />
                <Area
                    type="monotone"
                    dataKey="players"
                    stroke="#8884d8"
                    fillOpacity={1}
                    fill="url(#colorUv)"
                    tooltipType="none"
                    legendType="none"
                />
                <Line type="monotone" dataKey="players" name="Игроков" stroke="#8884d8" activeDot={{ r: 8 }} />
                <Line
                    type="monotone"
                    dataKey="max_players"
                    name="Максимум игроков"
                    stroke="#82ca9d"
                    strokeDasharray="5 5"
                    dot={false}
                />
            </ComposedChart>
        </ResponsiveContainer>
    </Box>
);

export default ServerOnlineChart;
